import { useState } from 'react';

export default function useMyLinkTab() {
  const [sendAnswerOfClaimToCollabEmail, setSendAnswerOfClaimToCollabEmail] = useState(false);
  const [allowCollabToSeeLetter, setAllowCollabToSeeLetter] = useState(false);
  const [allowMultipleConsults, setAllowMultipleConsults] = useState(false);
  const [usesCustomLogo, setUsesCustomLogo] = useState(false);
  const [integrateWithWs, setIntegrateWithWs] = useState(false);
  const [isMyLinkFull, setIsMyLinkFull] = useState(false);
  const [verifySalaryRJ, setVerifySalaryRJ] = useState(false);
  const [mustSendAddressProof, setMusStendAddressProof] = useState(true);

  return {
    sendAnswerOfClaimToCollabEmail,
    setSendAnswerOfClaimToCollabEmail,
    allowCollabToSeeLetter,
    setAllowCollabToSeeLetter,
    allowMultipleConsults,
    setAllowMultipleConsults,
    usesCustomLogo,
    setUsesCustomLogo,
    integrateWithWs,
    setIntegrateWithWs,
    isMyLinkFull,
    setIsMyLinkFull,
    verifySalaryRJ,
    setVerifySalaryRJ,
    mustSendAddressProof,
    setMusStendAddressProof,
  };
}
